import styles from "./index.module.css";
import React, { useState, useEffect } from "react";

import TabActionBar from "shared/TabActionBar";
import Button from "shared/Button";
import select from "shared/@utils/select";

import createNotification from "shared/@utils/createNotification";

import { ResetState } from "./useResetState";
import WithEmail from "./WithEmail";
import WithLink from "./WithLink";
import { IBOInfo } from "Membership/LookupByIBO/useIBOInfo";
import { useResetLink } from "./useResetLink";

export default function ({ iboNumber }) {
  const { isWaitingForEmail, isWaitingForLink } = ResetState.useContainer();
  const { iboInfo } = IBOInfo.useContainer();
  const { resetLink, getResetLink } = useResetLink({ iboNumber });

  const [content, setContent] = useState(null);

  const defaultEmail = iboInfo.primaryInfo.iboA.email;

  return (
    <div className={styles.container}>
      <TabActionBar>
        <Button
          disabled={isWaitingForEmail || isWaitingForLink}
          onClick={() => {
            setContent("email");
          }}
        >
          Send an Email
        </Button>
        <Button
          disabled={isWaitingForEmail || isWaitingForLink}
          onClick={() => {
            setContent("link");
            getResetLink();
          }}
        >
          Generate a Link
        </Button>
      </TabActionBar>
      <div className={styles.content}>
        {select(content, {
          email: () => (
            <WithEmail iboNumber={iboNumber} defaultEmail={defaultEmail} />
          ),
          link: () => <WithLink resetLink={resetLink} />,
          default: () => (
            <p>
              Choose an option above to help an IBO regain access to their
              account.
            </p>
          ),
        })}
      </div>
    </div>
  );
}
